import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Calendar = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" sx={{ mb: 3, fontWeight: 'bold', fontSize: '1.5rem', color: 'rgba(0, 0, 0, 0.87)' }}>
        Calendar
      </Typography>
      
      <Paper sx={{ p: 4, minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center', fontSize: '1.1rem' }}>
          Calendar functionality will be implemented here.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Calendar;
